<div class="banner__content col-12 col-lg-9 margin-10">
    <div class="row">
        <div class="banner__actions col-12 col-md-6">
            <div [ngClass]="show0 ? 'banner__sub banner__sub--inactive d-flex align-items-start':'banner__sub banner__sub--active d-flex align-items-start'"
                (click)="toggle(0)">
                <img class="mr-2" src="assets/img/id.png" alt="">
                <h3>Solicitar</h3>
            </div>
            <div [ngClass]="show0 ? 'animation-container--closed' : 'animation-container'">
                <div class="banner__list" id="request-collapsable">
                    <div class="banner__action" routerLink="/license/new">
                        <h5>Crear solicitud nueva licencia</h5>
                        <p>Formulario para empleados y contratistas.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/license/renew">
                        <h5>Renovar licencia</h5>
                        <p>Acceso para renovar documentos o contrato.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/license/extend">
                        <h5>Ampliar licencia</h5>
                        <p>Formulario para modificar equipos registrados.
                            <p>
                    </div>
                </div>
            </div>
        </div>
        <div class="banner__actions col-12 col-md-6">
            <div [ngClass]="show1 ? 'banner__sub banner__sub--inactive d-flex align-items-start':'banner__sub banner__sub--active d-flex align-items-start'"
                (click)="toggle(1)">
                <img class="mr-2" src="assets/img/verificar.png" alt="">
                <h3 class="pt-1">Verificación</h3>
            </div>

            <div [ngClass]="show1 ? 'animation-container--closed' : 'animation-container'">
                <div class="banner__list">
                    <div class="banner__action" routerLink="/verification/licenses">
                        <h5>Mis licencias</h5>
                        <p>Verificar estado de licencias.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/verification/requests" [state]="{ tabNumber:3}">
                        <h5>Mi historial de solicitudes</h5>
                        <p>Revisión del estado de solicitudes.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/verification/infractions" [state]="{ tabNumber:2}">
                        <h5>Mis sanciones</h5>
                        <p>Revisión del historial de sanciones.
                            <p>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <p class="info-banner">Despliega las categorías para acceder a las funciones del portal.</p>
</div>
